<template>
  <div>
    <form autocomplete="false" v-on:submit.prevent>
      <legend v-if="datas.num_dossier">Dossier N°{{datas.num_dossier}}</legend>
      <vue-form-generator :schema="schema" :model="datas" :options="formOptions">
      </vue-form-generator>
    </form>
  <div ref="clients_redirect"  style="display:none;"></div>
  <SignModal v-model="datas.signature" />
  </div>
</template>

<script>
import SignModal from '@/components/SignModal.vue'
import { getAllModeles, getPec, addPec, updatePec, deletePec, addHiboutikClient, checkHiboutikClient,searchZipCode, addAttachment, removeAttachment  } from '@/api/crm-api.js'

window.vm = {}

/* global vm */
/* global $ */
export default {
  components: {
    SignModal
  },
  props: {
    id: [String, Number]
  },
  data () {
    return {
      datas: { type:'Normal', hiboutik_client_id: 0 },
      zipcodes: [],
      modeles: [],
      schema: {
        groups: [
          {
            legend: 'Client',
            fields: [
              
              {
                type: 'input',
                inputType: 'text',
                label: 'Nom',
                model: 'client_nom',
                placeholder: 'Nom',
                styleClasses:'col-auto p-0 float-left',
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Prénom',
                model: 'client_prenom',
                placeholder: 'Prénom',
                styleClasses:'col-auto p-0 pl-5 ml-lg-0 float-xl-right',
              },
              {
                type: 'input',
                inputType: 'email',
                label: 'E-mail',
                model: 'client_mail',
                placeholder: 'E-mail'
              },
              {
                type: 'input',
                inputType: 'tel',
                label: 'Téléphone',
                model: 'client_tel',
                placeholder: 'Téléphone'
              },
              {
                type: 'textArea',
                label: 'Adresse',
                model: 'client_adresse',
                placeholder: 'Adresse'
              },
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                label: 'Code postal',
                model: 'client_zipcode',
                placeholder: 'Code postal',
                selectOptions: {
                  key: "code_postal",
                  label: "code_postal",
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: true,
                  showLabels: true,
                  allowEmpty:true,
                  hideSelected: false,
                  internalSearch: false,
                  selectLabel: "",
                  onSearch: (searchQuery) => {
                    if (searchQuery.length === 0) {
                      this.zipcodes = []
                    } else {
                      searchZipCode(searchQuery,1,10).then((response) => {
                          this.zipcodes = response.data
                      }).catch(() => { this.zipcodes = [] })
                    }
                  },
                  customLabel: ({ code_postal, ville }) => {
                    return code_postal ? `${code_postal} ${ville}` : this.datas.client_zipcode
                  }
                },
                onChanged: function(model, newVal) {
                  model.client_zipcode = newVal.code_postal  
                  model.client_city = newVal.ville
                },
                values: () => this.zipcodes
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Ville',
                model: 'client_city',
                placeholder: 'Ville'
              },
              {
                type: 'submit',
                buttonText: 'Ajouter dans Hiboutik',
                inputName: 'Ajouter dans Hiboutik',
                onSubmit: this.add_hiboutik_client,
                styleClasses:'col-auto p-0 float-left',
                validateBeforeSubmit: false,
                visible (modele) {
                    return modele != null && modele.id != null && modele.hiboutik_client_id == 0;
                }
              },
              {
                type: 'label',
                label: '<i class="fa fa-check text-success"></i> <a onclick="vm.vue.goToHiboutikClient(); return false;" href="#">Déja présent dans Hiboutik</a>',
                styleClasses:'col-auto p-0 float-left client-exist',
                visible (modele) {
                    return modele != null && modele.id != null && modele.hiboutik_client_id > 0;
                }
              },
              {
                type: 'submit',
                buttonText: 'Cloner',
                inputName: 'Cloner',
                onSubmit: this.clone,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: false,
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              },
            ]
          },
          {
            legend: 'Machine',
            fields: [
              // {
              //   type: 'select',
              //   model: 'modele_id',
              //   label: 'Modèle',
              //   selectOptions: { name:'nom', noneSelectedText: 'Non selectionné' },
              //   values: () => { return this.modeles }
              // },
              {
                type: 'vueMultiSelect',
                // inputType: 'string',
                label: 'Modèle',
                model: 'modele',
                placeholder: 'Modèle',
                selectOptions: {
                  key: "id",
                  label: "nom",
                  trackBy: "id",
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: true,
                  showLabels: true,
                  allowEmpty:true,
                  hideSelected: false,
                  internalSearch: true,
                  selectLabel: "",
                  deselectLabel: "",
                },
                onChanged: function(model, newVal) {
                  model.modele_id = newVal.id  
                },
                values: () => this.modeles
              },
              {
                type: 'input',
                inputType: 'text',
                model: 'modele_other',
                placeholder: 'Modèle non référencé',
                visible (modele) {
                    return modele != null && modele.modele_id == 0;
                }
              },
              {
                type: 'input',
                inputType: 'text',
                model: 'serial',
                label: 'N° Serie',
                placeholder: 'N° Serie'
              },
              {
                type: 'input',
                inputType: 'text',
                model: 'pass',
                label: 'Mot de passe',
                placeholder: 'Mot de passe'
              },
            ]
          },
          {
            legend: 'Panne',
            fields: [
              {
                type: 'textArea',
                rows:3,
                model: 'panne',
                placeholder: 'Description'
              },
              {
                type: 'textArea',
                rows:3,
                model: 'solution',
                placeholder: 'Solution',
                label: 'Solution'
              },
              {
                type: 'select',
                model: 'type',
                label: 'Type',
                selectOptions: { noneSelectedText: 'Non selectionné' },
                values: ["Normal","Express"]
              },
              {
                type: 'textArea',
                rows:3,
                model: 'etat_initial',
                placeholder: 'Etat Initial',
                label: 'Etat Initial'
              },
            ]
          },
          {
            legend: 'Pieces jointes',
            fields: [
              {
                type: 'attachments',
                model: 'attachments',
                onAdded: this.attachment_add,
                onRemoved: this.attachment_remove,
                onClick: this.view_attachment
              }
            ]
          },
          {
            legend: 'Signature',
            fields: [
              {
                type: 'imageDisplay',
                model: 'signature',
                height: '100px',
                width: '100%',
                styleClasses:'col-auto p-0',
                visible (modele) {
                    return modele != null && modele.signature != null;
                },
                onClick: this.sign,
              },
              {
                type: 'submit',
                buttonText: 'Signer',
                onSubmit: this.sign,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: false,
                visible (modele) {
                    return modele != null && modele.signature == null;
                }
              }
            ]
          },
          {
            legend: '',
            fields: [
              {
                type: 'submit',
                buttonText: 'Ajouter',
                onSubmit: this.add,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: true,
                visible (modele) {
                    return modele != null && modele.id == null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Sauver',
                inputName: 'Sauver',
                validateBeforeSubmit: true,
                onSubmit: this.update,
                styleClasses:'col-auto p-0 float-right',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Supprimer',
                inputName: 'Supprimer',
                validateBeforeSubmit: false,
                onSubmit: this.delete,
                styleClasses:'col-auto float-left p-0',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  methods: {
    add () {
      addPec(this.datas).then((response) => {
        this.$router.push({name:'pecManager', params:{ id: response.data.id }}).catch(() => {})
        this.$store.commit('addMessage',{text:'Le dossier N°' + response.data.num_dossier + ' à été crée', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    update () {
      updatePec(this.id,this.datas).then(() => {
        this.$store.commit('addMessage',{text:'Le dossier N°' + this.datas.num_dossier + ' à été mis à jour', status:'success'})
        this.$emit('onUpdate')
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    delete () {
      if (confirm("Etes vous sur de vouloir supprimer le dossier N°" + this.datas.num_dossier)){
        deletePec(this.id).then(() => {
          this.$emit('onDelete')
          this.$store.commit('addMessage',{text:'Le dossier N°' + this.datas.num_dossier + ' à été supprimé', status:'success'})
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
        })
      }
    },
    clone () {
      //Copy object
      var partial_datas = JSON.parse(JSON.stringify(this.datas))
      //Set all values to null;
      let setAll = (obj, val) => Object.keys(obj).forEach(k => obj[k] = val);
      let setNull = obj => setAll(obj, null);
      setNull(partial_datas);

      //Set only some values on object
      partial_datas['client_nom'] = this.datas['client_nom'];
      partial_datas['client_prenom'] = this.datas['client_prenom'];
      partial_datas['client_adresse'] = this.datas['client_adresse'];
      partial_datas['client_zipcode'] = this.datas['client_zipcode'];
      partial_datas['client_city'] = this.datas['client_city'];
      partial_datas['client_tel'] = this.datas['client_tel'];
      partial_datas['client_mail'] = this.datas['client_mail'];
      partial_datas['type'] = 'Normal';

      addPec(partial_datas).then((response) => {
        this.$router.push({name:'pecManager', params:{ id: response.data.id }}).catch(() => {})
        this.$store.commit('addMessage',{text:'Le dossier N°' + response.data.num_dossier + ' à été crée', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    add_hiboutik_client () {
      addHiboutikClient(this.datas).then((response) => {
        checkHiboutikClient(this.datas.client_mail).then((response) => {
            this.datas.hiboutik_client_id = response.data
            // this.goToHiboutikClient()
        }).catch(() => {})
        
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    goToHiboutikClient () {
      //Open window to hiboutik client
      let client_id =  this.datas.hiboutik_client_id
      $(this.$refs.clients_redirect).html('<form name="client-'+client_id+'-redirect" action="https://macinstore.hiboutik.com/" target="client-'+client_id+'" method="post" style="display:none;"><input type="hidden" name="show_tab" value="clients" /><input type="hidden" name="mon_client_affiche" value="'+client_id+'"></form>');
      document.forms['client-'+client_id+'-redirect'].submit()
    },
    sign () {
      this.$modal.show('sign-modal')
    },
    getBase64 (file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    },
    attachment_add (a,b,$event) {
      let target = $event.target
      if (target && target.files) {
        let file = target.files[0]

        this.getBase64(file).then((b64) => {
          addAttachment(this.id,{name:file.name, file: b64}).then((response) => {
            this.datas.attachments = response.data;
            this.$store.commit('addMessage',{text:'Piece jointe ajoutée', status:'success'})
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
          })
        })
      }
    },
    attachment_remove (attachment) {
      removeAttachment(this.id,attachment).then((response) => {
        this.datas.attachments = response.data;
        this.$store.commit('addMessage',{text:'Piece jointe supprimé', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    view_attachment (attachment) {
      window.open('https://www.macinstore.fr/crm-api/api/pecs/'+this.id+'/attachments/'+attachment, '_blank');
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        if(this.id != null) {
          getPec(this.id)
          .then((response) => {
            this.datas = { ...response.data, hiboutik_client_id: 0, modele: {id: response.data.modele_id} }
            checkHiboutikClient(this.datas.client_mail).then((response) => {
              this.datas.hiboutik_client_id = response.data
            }).catch(() => {})
            if(this.datas.modele_id != null) {
              if(this.modeles.length == 0) {
                getAllModeles()
                .then((response) => {
                  this.modeles = response.data.records
                  this.datas.modele = this.modeles.find(m => m.id == this.datas.modele_id)
                })
              } else {
                this.datas.modele = this.modeles.find(m => m.id == this.datas.modele_id)
              }
            }
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
          })
        } else {
          this.datas = { type:'Normal', hiboutik_client_id: 0 }
        }
      }
    }
  },
  mounted () {
    getAllModeles()
    .then((response) => {
      this.modeles = response.data.records
    })
    .catch((error) => {
      this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
    })
  },
  created () {
    vm.vue = this;
  }
}
</script>
<style>
.form-control[disabled] {
    background-color: #e9ecef !important;
    opacity: 1;
}

.vue-form-generator .form-group.client-exist.field-label span {
  margin: 0px;
  font-style: italic;
}

.vue-dialog-buttons button:focus {
    outline: none;
}
</style>
